import React, { useState } from 'react'
import SlotMachine from '../../components/SlotMachine'
import EvaluatorModal from '../../components/EvaluatorModal'
import questionAnswers from '../questionAnswers'


function RouterScreen(props) {

  const [answers, setAnswers] = useState([])
  const { appState, updateAppState } = props
  const [questionIndex, setQuestionIndex] = useState(appState.questionIndex)
  const [currentScreen, setCurrentScreen] = useState("Quiz")
  const [modalOpend, setModalOpend] = useState(appState.initModal)

  // const isQuizCompleted = () => (!(questionIndex + 1 < questionAnswers.length)) && setCurrentScreen("Result")

  const nextQuestion = () => {
    // isQuizCompleted()
    updateAppState({ questionIndex: questionIndex + 1, initModal: false })
    setQuestionIndex(questionIndex + 1)
  }

  return (
      <>
      {modalOpend && <EvaluatorModal setModalOpend={setModalOpend} />}
      {currentScreen === "Quiz" && <SlotMachine
        setCurrentScreen={setCurrentScreen}
        questionIndex={questionIndex}
        nextQuestion={nextQuestion}
        question={questionAnswers[questionIndex]}
        appState={appState}
        updateAppState={updateAppState}
       />}

      {/* {currentScreen === "Tutorial" && <TutorialScreen setCurrentScreen={setCurrentScreen} />}
      {currentScreen === "Quiz"     && <QuizScreen     setAnswers={setAnswers} setCurrentScreen={setCurrentScreen} />}
      {currentScreen === "Result"   && <ResultScreen answers={answers} setAnswers={setAnswers} setCurrentScreen={setCurrentScreen} />} */}
      </>
  )
}

export default RouterScreen
